import { useNavigate } from "@opendash/router";
import { AdminToolbar } from "@opendash/ui";
import { Alert, Flex } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useMemo, useState } from "react";
import { $framework, AdminLayout, search, useTranslation } from "..";

type Props = {};

type NavItem = {
  id: string;
  label: string;
  icon: string;
  link?: string | (() => void);
  children?: NavItem[];
};

/**
 * Works only for a group with one child layer but not for a child with children
 */
export default observer((props: Props) => {
  const t = useTranslation();
  const navigate = useNavigate();
  const [mappedNavGroups, setMappedNavGroups] = useState<NavItem[]>([]);
  const [searchValue, setSearchValue] = useState(undefined);

  useEffect(() => {
    const mappedGroups = $framework.ui.staticNavigationGroups
      .filter((item) => item.id.includes("admin"))
      .map((group) => {
        return {
          id: group.id,
          label: group.label,
          icon: group.icon,
          children: $framework.ui.staticNavigationItems
            .filter((item) => item.group === group.id)
            .map((item) => {
              return {
                id: item.id,
                label: item.label,
                icon: item.icon,
                group: item.group,
                link: item.link,
              };
            }),
        };
      })
      .sort((a, b) => {
        //Sort based on the number of children
        if (a.children.length > b.children.length) {
          return -1;
        }
        if (a.children.length < b.children.length) {
          return 1;
        }
        return 0;
      });

    setMappedNavGroups(mappedGroups);
  }, []);

  const navitems: NavItem[] = useMemo(() => {
    if (!searchValue) {
      return mappedNavGroups;
    }

    return search(searchValue, mappedNavGroups, (row) => {
      if (row.children) {
        return row.children.map((child) => {
          return t(child.label).toLowerCase();
        });
      }

      return t(row.label).toLowerCase();
    });
  }, [searchValue, mappedNavGroups.length]);

  return (
    <AdminLayout contentPadding>
      <AdminToolbar
        title={t("opendash:administration.overview.headline")}
        // search={searchValue}
        // onSearch={(value: string) => {
        //   if (!value) setSearchValue(undefined);
        //   else setSearchValue(value);
        // }}
      />
      <div className="od-page-main">
        <Flex vertical gap={12} align="stretch" justify="start">
          <Alert
            message={t("opendash:administration.overview.info")}
            type="info"
          />
          {/* <Flex
            gap={12}
            align="stretch"
            justify="start"
            wrap="wrap"
            // flex="0 1 20%"
          >
            {navitems.map((groupitem) => (
              <Card
                title={
                  <>
                    <Icon icon={groupitem.icon} /> {t(groupitem.label)}
                  </>
                }
                style={{ width: 300 }}
              >
                {groupitem.children.map((item) => {
                  return (
                    <Card.Grid
                      key={item.label}
                      style={{ width: "100%", cursor: "pointer" }}
                      onClick={() => {
                        item && item.link && typeof item.link === "string"
                          ? navigate(item.link)
                          : () => {};
                      }}
                    >
                      {item.label ? <Icon icon={item.icon} /> : null}{" "}
                      {t(item.label)}
                    </Card.Grid>
                  );
                })}
              </Card>
            ))}
          </Flex> */}
        </Flex>
      </div>
    </AdminLayout>
  );
});
